import MESSAGES from "@constants/messages.constants";
import { setAlertMessage } from "@reducers/alert.reducer";
import PermissionDeniedComponent from "@screens/permission-denied/permission-denied.component";
import { checkMenuAccess } from "@utils/menu-auth";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { menuUrl } from "../manufacturer-list/model/manufacturer-list.constants";
import { createManufacturer } from "./manufacturer-create.component.service";
import ManufacturerCreateTemplateComponent from "./manufacturer-create-template.component";
import { getManufacturerInputs } from "../model/manufacturer.modal";
import { PRIMARY_KEY } from "@constants/app.constants";
import { useEffect } from "react";  
import {getManufacturers} from "../manufacturer-create/manufacturer-create.component.service";


const {
  ALERT_TYPES: { SUCCESS, ERROR },
  MANUFACTURER_ALERTS: { CREATE_ALERT } 
} = MESSAGES;

const ManufacturerCreateComponent = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const menuAccess = checkMenuAccess(menuUrl, "write");
  const [formInputs, setFormInputs] = useState([]);
  const [formTriggers, setFormTriggers] = useState({
    submitTrigger: 0,
    validationTrigger: 0,
  });

  const handleTriggerClick = (type) => {
    if (type === "SUBMIT") {
      setFormTriggers({
        ...formTriggers,
        submitTrigger: formTriggers.submitTrigger + 1,
      });
    }
  };

  const handleBackClick = () => {
    history.push(`/${menuUrl}`);
  };

  const handleSubmit = async ({ values, errors }) => {
    // INFO : check for errors and return if errors found
    if (errors.length > 0) return;

    // INFO :  construct payload
    let manufacturerPayload = {};
    for (let i = 0; i < values.length; i++) {
      manufacturerPayload[values[i].name] = values[i].value;
    }

    // INFO : call create api
    const manufacturerResponse = await createManufacturer(manufacturerPayload);

    // INFO : check api response and show relevant alert message
    if (manufacturerResponse.status) {
      dispatch(setAlertMessage({ type: SUCCESS, message: CREATE_ALERT }));
      history.push(`/${menuUrl}`);
    } else {
      dispatch(
        setAlertMessage({ type: ERROR, message: manufacturerResponse.message })
      );
    }
  };

  const onLoad = async () => {
    const categoryResponse = await getManufacturers();

    if (categoryResponse.status) {
      const formattedCategories = categoryResponse.data.map((cat) => ({
        name: cat.name,
        value: cat[PRIMARY_KEY], 
      }));

      const formInputData = getManufacturerInputs(formattedCategories, {});
      setFormInputs(formInputData);
      setFormTriggers({ ...formTriggers, loading: false });
    }
  };

  useEffect(() => {
    onLoad();
  }, []);

  const templateModal = {
    formTriggers,
    formInputs: getManufacturerInputs({}),
  };

  const templateEvents = {
    handleSubmit,
    handleTriggerClick,
    handleBackClick,
  };

  return menuAccess ? (
    <ManufacturerCreateTemplateComponent
      templateModal={templateModal}
      templateEvents={templateEvents}
    />
  ) : (
    <PermissionDeniedComponent />
  );
};

export default ManufacturerCreateComponent;